import * as yup from 'yup';
import Schema from '@/schema/Schema';
import Constant from '@/common/constant/Constant';

const CreateFormSchema = Schema.object().shape({
    name: yup.string().required('フォーマット名をご記入ください。').max(Constant.MAX_LENGTH.FORM_NAME, `${Constant.MAX_LENGTH.FORM_NAME}文字の以下で入力してください。`).trim(),
});

export default CreateFormSchema;
